import loadable from '@loadable/component'

export const BrightcoveVideo = loadable(() => import('./BrightcoveVideo'))
export const VideoListItem = loadable(() => import('./VideoListItem'))
export const VideoList = loadable(() => import('./VideoList'))
export const Videos = loadable(() => import('./Videos'))
export const VideoThumb = loadable(() => import('./VideoThumb'))
export type { VideoProps } from './BrightcoveVideo'
export type { VideoListItemProps, VideoListImage } from './VideoListItem'
export type { VideoListProps } from './VideoList'
export type { VideosItem, VideosProps } from './Videos'
export type { VideoThumbProps } from './VideoThumb'
